import { ProtectedRoute, ThemeProvider } from '@invisoutlet/shared/components';
import { AuthProvider } from '@invisoutlet/shared/context';
import { Navigate, Route, Routes } from 'react-router-dom';
import EntitiesPage from './routes/entities.js';
import EntityDetailPage from './routes/entity-detail.js';
import LoginPage from './routes/login.js';
import UsersPage from './routes/users.js';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected — requires role: 'admin' */}
          <Route element={<ProtectedRoute requiredRole="admin" />}>
            {/* Redirect root to entities list */}
            <Route path="/" element={<Navigate to="/entities" replace />} />
            <Route path="/entities" element={<EntitiesPage />} />
            <Route path="/entities/:entityId" element={<EntityDetailPage />} />
            <Route path="/users" element={<UsersPage />} />
            {/* Placeholder routes for future pages */}
            <Route path="/devices" element={<PlaceholderPage title="Devices" />} />
            <Route path="/impersonation" element={<PlaceholderPage title="Impersonation" />} />
            <Route path="/audit" element={<PlaceholderPage title="Audit Log" />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

// ─── Temporary placeholder for unimplemented pages ───────────────────────────

import { InternalLayout } from './components/internal-layout.js';

function PlaceholderPage({ title }: { title: string }) {
  return (
    <InternalLayout title={title}>
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-bg-elevated text-text-secondary">
          <svg
            className="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            aria-hidden="true"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
        </div>
        <h2 className="text-base font-semibold text-text-primary">{title}</h2>
        <p className="mt-1 text-sm text-text-secondary">Coming soon — not yet implemented.</p>
      </div>
    </InternalLayout>
  );
}
